import axios from "axios"

const API_URL = process.env.VUE_APP_API_URL

class AuthService {
    login(user) {
        return axios.post(API_URL + 'LoginWeb', {
            email: user.email,
            password: user.password
        }).then(res => {
            if (res.data.data.result.access_token) {
                localStorage.setItem('user', JSON.stringify(res.data.data.result.User))
                localStorage.setItem('accessToken', JSON.stringify(res.data.data.result.access_token))
            } 
            return res.data
        })
    }
    logout() {
        localStorage.removeItem('user')
        localStorage.removeItem('accessToken')
    }
}

export default new AuthService()